<template>
  <Dialog
    v-model:visible="showModal"
    :draggable="false"
    modal
    class="max-w-90vw"
    :style="`height: ${height}; width: ${width}; max-width: 90vw;`"
    @hide="closeModal"
    data-test="modal"
  >
    <template #header>
      <div
        class="modal-header"
        :data-cy="`${props.dataCy}ModalHeader`"
        ref="modalHeader"
      >
        <slot name="header"></slot>
      </div>
    </template>
    <div
      class="modal-body"
      :style="`${props.bodyFullHeight ? 'height: 100%;' : ''}`"
      :data-cy="`${props.dataCy}ModalBody`"
    >
      <slot></slot>
    </div>
    <template #footer>
      <div
        class="modal-footer"
        ref="modalFooter"
        data-test="modalFooter"
      >
        <slot name="footer"></slot>
      </div>
    </template>
  </Dialog>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useDonorStore } from '@/stores/DonorStore.js';

const props = defineProps({
  show: Boolean,
  width: { type: String, default: '580px' },
  height: { type: String, default: 'auto' },
  justifyContent: { type: String, default: 'flex-start' },
  textAlign: { type: String, default: 'left' },
  dataCy: { type: String, default: '' },
  bodyFullHeight: { type: Boolean, default: false },
});

const emits = defineEmits(['close']);

const showModal = ref(props.show);

const closeModal = () => {
  showModal.value = false;
  emits('close');
};
const donorStore = useDonorStore();
const mainColor = donorStore.mainColor;

watch(
  () => props.show,
  (newVal) => {
    showModal.value = newVal;
    if (!newVal) {
      closeModal();
    }
  },
);
</script>

<style scoped>
.scrollbar::-webkit-scrollbar {
  width: 10px;
  height: 20px;
}

.scrollbar::-webkit-scrollbar-track {
  background: #fff;
}

.scrollbar::-webkit-scrollbar-thumb {
  background: var(--p-primary-500);
}

.scrollbar::-webkit-scrollbar-thumb:hover {
  background: var(--p-primary-500);
}
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 7000;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.25);
  transition: opacity 0.5s ease;
}

.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 8000;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  transition: opacity 0.5s ease;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: 9000;
  /* max-height: 100%; */
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  transition: opacity 0.5s ease, transform 0.5s ease;
  background-color: #ffffff;
}

.modal-close {
  padding-right: 1rem;
  position: absolute;
  right: 0;
  padding-top: 0.5rem;
}

.modal-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: #ffffff;
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--p-primary-500);
  max-width: 100%;
}

.modal-body {
  display: flex;
  justify-content: v-bind(justifyContent);
  font-size: 0.9rem;
  text-align: v-bind(textAlign);
  flex: 1;
}

.modal-footer {
  display: flex;
  justify-content: space-between;
  grid-column: span 2;
  width: 100%;
  align-items: center;
}

.close-button {
  margin: 0;
  cursor: pointer;
  border: none;
  background: none;
  padding: 0;
  font-size: 2rem;
  font-weight: lighter;
}

@media screen and (max-width: 768px) {
  .modal-content {
    width: 341px;
  }
  .modal-body {
    align-items: flex-start;
  }
  .modal-header {
    font-size: 1.875rem;
  }
}
</style>

<style>
.modal-body {
  .overflow-y-scroll {
    overflow: auto;
    background:
        /* Shadow covers */ linear-gradient(white 30%, rgba(255, 255, 255, 0)),
      linear-gradient(rgba(255, 255, 255, 0), white 70%) 0 100%,
      /* Shadows */ radial-gradient(50% 0, farthest-side, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0)),
      radial-gradient(50% 100%, farthest-side, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0)) 0 100%;

    background:
        /* Shadow covers */ linear-gradient(white 30%, rgba(255, 255, 255, 0)),
      linear-gradient(rgba(255, 255, 255, 0), white 70%) 0 100%,
      /* Shadows */ radial-gradient(farthest-side at 50% 0, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0)),
      radial-gradient(farthest-side at 50% 100%, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0)) 0 100%;

    background-repeat: no-repeat;
    background-color: white;
    background-size: 100% 40px, 100% 40px, 100% 14px, 100% 14px;

    /* Opera doesn't support this in the shorthand */
    background-attachment: local, local, scroll, scroll;
  }
}
</style>
